/** @jsxImportSource @emotion/react */
import React from 'react'

import * as styles from './styles'

export default function Emoji30() {
  return (
    <svg width="100%" height="100%" viewBox="0 0 45 45" css={styles.svg}>
      <g transform="matrix(1,0,0,1,-757.256,-3705.93)">
        <g transform="matrix(0.683279,0,0,0.683279,373.769,3232.44)">
          <g transform="matrix(0.937093,0,0,0.937093,92.4925,132.854)">
            <g opacity="0.75">
              <g transform="matrix(1,0,0,1,0.5,0.5)">
                <path
                  d="M534.88,597.22c-0.007,0 -0.013,0 -0.02,0c-19.277,0 -35.14,15.863 -35.14,35.14c0,19.277 15.863,35.14 35.14,35.14c19.277,0 35.14,-15.863 35.14,-35.14c-0.027,-19.267 -15.873,-35.113 -35.14,-35.14m0,65.89c-16.869,0 -30.75,-13.881 -30.75,-30.75c0,-16.869 13.881,-30.75 30.75,-30.75c16.869,0 30.75,13.881 30.75,30.75c-0.022,16.861 -13.889,30.728 -30.75,30.75"
                  css={styles.svg}
                />
              </g>
              <g transform="matrix(1,0,0,1,0.5,0.5)">
                <path
                  d="M555.38,636.88c-0.237,-0.085 -0.487,-0.129 -0.739,-0.129c-0.928,0 -1.758,0.592 -2.061,1.469c-2.36,6.67 -10,11.71 -17.7,11.71c-7.7,0 -15.34,-5 -17.69,-11.71c-0.32,-0.86 -1.145,-1.434 -2.062,-1.434c-1.207,0 -2.2,0.993 -2.2,2.2c0,0.236 0.038,0.47 0.112,0.694c3,8.49 12.18,14.64 21.84,14.64c9.66,0 18.84,-6.15 21.84,-14.64c0.398,-1.136 -0.206,-2.397 -1.34,-2.8"
                  css={styles.svg}
                />
              </g>
              <g transform="matrix(1,0,0,1,0.5,0.5)">
                <path
                  d="M521.7,623.58l4.4,0c1.207,0 2.2,-0.993 2.2,-2.2c0,-1.207 -0.993,-2.2 -2.2,-2.2l-4.4,0c-1.207,0 -2.2,0.993 -2.2,2.2c0,1.207 0.993,2.2 2.2,2.2"
                  css={styles.svg}
                />
              </g>
              <g transform="matrix(1,0,0,1,0.5,0.5)">
                <path
                  d="M543.67,623.58l4.39,0c1.207,0 2.2,-0.993 2.2,-2.2c0,-1.207 -0.993,-2.2 -2.2,-2.2l-4.39,0c-1.207,0 -2.2,0.993 -2.2,2.2c0,1.207 0.993,2.2 2.2,2.2"
                  css={styles.svg}
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}
